"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterInitRequest = void 0;
var CenterInitRequest = /** @class */ (function () {
    function CenterInitRequest() {
    }
    return CenterInitRequest;
}());
exports.CenterInitRequest = CenterInitRequest;
;
//# sourceMappingURL=centerInit.request.js.map